import { c as _c } from "react/compiler-runtime";
import { Heading, TextPassage } from '@petsmart-ui/sparky';
import type { ReactNode } from 'react';
import { COLOR_TABLE } from '../../constants';
import type { TextColor } from '../../types';
interface TextProps {
  color?: TextColor;
  children: ReactNode;
  className?: string;
  align?: 'center';
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}
export function Text(t0) {
  const $ = _c(16);
  let as;
  let c;
  let p;
  if ($[0] !== t0) {
    ({
      color: c,
      as,
      ...p
    } = t0);
    $[0] = t0;
    $[1] = as;
    $[2] = c;
    $[3] = p;
  } else {
    as = $[1];
    c = $[2];
    p = $[3];
  }
  let t1;
  if ($[4] !== c) {
    t1 = c && {
      color: COLOR_TABLE[c]
    };
    $[4] = c;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = {
      ...t1
    };
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== p || $[9] !== t2) {
    t3 = {
      style: t2,
      ...p
    };
    $[8] = p;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const props = t3;
  if (as) {
    let t4;
    if ($[11] !== as || $[12] !== props) {
      t4 = <Heading tagName={as} {...props} />;
      $[11] = as;
      $[12] = props;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  let t4;
  if ($[14] !== props) {
    t4 = <TextPassage {...props} />;
    $[14] = props;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}